import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["boxSize", "color"];
import React from 'react';
import { BaseIcon } from "../../../index.js";
export var PdfFile = function PdfFile(_ref) {
  var boxSize = _ref.boxSize,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'grey.900' : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(BaseIcon, _extends({
    w: "16px",
    h: "16px",
    viewBox: "0 0 16 16",
    boxSize: boxSize,
    color: color,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M14.4 0H4.8C3.92 0 3.2 0.72 3.2 1.6V11.2C3.2 12.08 3.92 12.8 4.8 12.8H14.4C15.28 12.8 16 12.08 16 11.2V1.6C16 0.72 15.28 0 14.4 0ZM7.6 6C7.6 6.664 7.064 7.2 6.4 7.2H5.6V8.2C5.6 8.528 5.328 8.8 5 8.8C4.672 8.8 4.4 8.528 4.4 8.2V4.8C4.4 4.36 4.76 4 5.2 4H6.4C7.064 4 7.6 4.536 7.6 5.2V6ZM11.6 7.6C11.6 8.264 11.064 8.8 10.4 8.8H8.8C8.576 8.8 8.4 8.624 8.4 8.4V4.4C8.4 4.176 8.576 4 8.8 4H10.4C11.064 4 11.6 4.536 11.6 5.2V7.6ZM14.8 4.6C14.8 4.928 14.528 5.2 14.2 5.2H13.6V6H14.2C14.528 6 14.8 6.272 14.8 6.6C14.8 6.928 14.528 7.2 14.2 7.2H13.6V8.2C13.6 8.528 13.328 8.8 13 8.8C12.672 8.8 12.4 8.528 12.4 8.2V4.8C12.4 4.36 12.76 4 13.2 4H14.2C14.528 4 14.8 4.272 14.8 4.6ZM5.6 6H6.4V5.2H5.6V6ZM0.8 3.2C0.36 3.2 0 3.56 0 4V14.4C0 15.28 0.72 16 1.6 16H12C12.44 16 12.8 15.64 12.8 15.2C12.8 14.76 12.44 14.4 12 14.4H2.4C1.96 14.4 1.6 14.04 1.6 13.6V4C1.6 3.56 1.24 3.2 0.8 3.2ZM9.6 7.6H10.4V5.2H9.6V7.6Z",
    fill: color
  }));
};